const prefix = ''

export const indicatorUrls = {
  'indicator.list': `${prefix}/indicators`,
  'indicator.edit': (id = ':indicatorId') => `${prefix}/indicators/${id}/edit`,
  'indicator.add': `${prefix}/indicators/add`,
}
